import React from 'react';

import styled from 'styled-components';
import StudentMyCoursesList from './components/StudentMyCoursesList';
import StudentRelatedCourses from './components/StudentRelatedCourses';
import StudentInfo from './components/StudentInfo';
import StudentClassCoursesList from './components/StudentClassCoursesList';

import Header from '../../components/Header';

const StudentPage = () => {
  return (
    <Container>
      <Header />
      <Main>
        <StudentInfo />
        <StudentClassCoursesList />
        {/* <StudentMyCoursesList />
        <StudentRelatedCourses /> */}
      </Main>
    </Container>
  );
};

const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  position: relative;
`;

const Main = styled.main`
  padding-top: 10vh;
  max-width: 1120px;
  width: 80%;
  margin: 0 auto;
`;

export default StudentPage;
